import { Text } from '@talkdesk/cobalt-react-typography'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import Base from '../../pages/Base'
import MFAHeader from '../../components/MFAHeader'
import MFACard from '../../components/MFACard'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const MFASelector = ({
  brandingSettings,
  mfas,
  selectMFA,
  changeStep,
  showGoogleFooterLink,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Base
      brandingSettings={brandingSettings}
      showGoogleFooterLink={showGoogleFooterLink}
    >
      <MFAHeader
        title={t('mfaSelector.title')}
        subtitle={t('mfaSelector.subtitle')}
      />
      {mfas.map((mfa) => {
        return (
          <MFACard
            key={mfa.type}
            mfaType={mfa.type}
            selectMFA={selectMFA}
            changeStep={changeStep}
          />
        )
      })}
      <Box paddingTop={5}>
        <Flex alignX='center'>
          <Text color={theme.gray11} size='small'>
            {t('mfaSelector.footnote')}{' '}
          </Text>
        </Flex>
      </Box>
    </Base>
  )
}

export default MFASelector
